/* ContactAddress.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Fieldset } from '@atlaskit/form';
import { media } from '@atlaskit/primitives/responsive';
import { H2 } from '@atlassian/mpac-primitives';
import { CountrySelectInput, TextInput } from '@atlassian/mpac-ui';
import { validateAddressLine1, validateCity, validateCountry, validatePostalCode, validateState } from '../ManageVendorCreate.utils';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _11 = "@media (min-width:48rem){._14b5tye8{width:20rem}}";
const _10 = "._1bsb1osq{width:100%}";
const _9 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _6 = "._18s81lvv{margin:var(--_mog0om)}";
const _5 = "._11c81o8v{font:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _4 = "@media (min-width:48rem){._6ytt47zb{padding:var(--_o3usm9)}}";
const _3 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _2 = "._otyridpf{margin-bottom:0}";
const _ = "._1yt4zmd4{padding:var(--_1aun1c5)}";
const FieldsetTitleH2 = null;
const ContactAddressLegend = null;
const LeftPadding = null;
const FieldWidth20 = null;
export const ContactAddress = _ref => {
  let {
    submissionErrors
  } = _ref;
  return /*#__PURE__*/_jsxs(Fieldset, {
    legend: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4]
      }), /*#__PURE__*/_jsx(H2, {
        className: ax(["_1yt4zmd4 _otyridpf _k48p1wq8 _6ytt47zb"]),
        style: {
          "--_1aun1c5": ix("var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-050, 4px)")),
          "--_o3usm9": ix("var(--ds-space-400, 32px)".concat(" 0 ", "var(--ds-space-025, 2px)"))
        },
        children: "Contact address"
      })]
    }),
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_5, _6, _7]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_11c81o8v _18s81lvv _syaz131l"]),
        style: {
          "--_mog0om": ix("var(--ds-space-050, 4px)".concat(" 0 ", "var(--ds-space-250, 20px)"))
        },
        children: "This will be the same as your billing address. You can update the billing address later in your account settings."
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_8, _9]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_19bvidpf _1r3v1epz"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "addressLine1",
              label: "Address Line 1",
              width: "100%",
              validate: validateAddressLine1,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.addressLine1
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "addressLine2",
              label: "Address Line 2",
              width: "100%",
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.addressLine2
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "city",
              label: "City",
              width: "100%",
              validate: validateCity,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.city
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "state",
              label: "State",
              width: "100%",
              validate: validateState,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.state
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "postalCode",
              label: "Postal Code",
              width: "100%",
              validate: validatePostalCode,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.postalCode
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(CountrySelectInput, {
              name: "country",
              label: "Country",
              validate: validateCountry
            })
          })]
        })]
      })]
    })]
  });
};